import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchUserList,
  createUser,
  updateUser,
  deleteUser
} from '../../modules/user'

import {
  Card,
  Table,
  Button,
  Avatar,
  Tag,
  Divider,
  Popconfirm
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import UserForm from './components/UserForm'

const Users = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})

  const { userList  } = useSelector(
    (state) => ({
      userList: state.user.userList.data
    }),
    []
  )
  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchUserList())
    }

    fetch()
  }, [])

  const GetStatusColor = (status) => {
    let color = ''
    switch (status) {
      case status = 'ENABLED':
        color = 'green'
        break
      case status = 'DISABLED':
        color = 'red'
        break

      default:
        break
    }
    return color
  }


  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(fetchUserList())
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateUser(data))
    } else {
      await dispatch(createUser(data))
    }

    await dispatch(fetchUserList())
    await setVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteUser(id))
    await dispatch(fetchUserList())
  }
  const columns = [
    {
      title: 'Name',
      dataIndex: ['name', 'avatar'],
      key: 'name',
      render: (name,row) => (
        <div>
          <Avatar src={row["avatar"]} /> 
          &nbsp; &nbsp;{row["name"]}
        </div>
      )
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="Users"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            New User
          </Button>
        </div>
      }>
      <Table
        scroll={{ x: 1000 }}
        rowKey={(record) => record.id}
        dataSource={userList}
        columns={columns}
      />
      <UserForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(Users)






// WEBPACK FOOTER //
// ./src/pages/Users/index.js